
import type { PropType } from 'vue'
import type { TripsAnalyticItem } from '@/new-services/types/tms'

import { defineComponent, ref } from 'vue'

import ContainerIndicator from './ContainerIndicator.vue'

import { formatDateWithTimeFromBackend } from '@/common/helpers/formatDate'

export default defineComponent({
    components: {
        ContainerIndicator
    },
    props: {
        item: {
            type: Object as PropType<TripsAnalyticItem>,
            required: true
        }
    },
    setup() {
        const is_opened = ref(false)
        const toggle = () => is_opened.value = !is_opened.value

        return {
            is_opened,
            toggle,
            formatDateWithTimeFromBackend
        }
    }
})
